module.exports = __webpack_public_path__ + "static/media/Step 2-Story_Cards.2b0cbfd1.png";